SJ.higherJumperSpeed = 0;
SJ.higherJumperHeight = 0;

SJ.ScoreCounter = class {
	constructor() {
		this.restart();
	}

	restart() {
		this.landingHeight = 0;
		this.jumperHeight = 0;
		this.jumperJumpPoint = 0;
		this.jumperJumpSpeed = 0;

		this.arbiterRates = [];
		this.crashPoints = 0;

		this.arbiterRatesScore = 0;

		this.showJumpScoreDisplay = () => { };
		this.showJumpParamDisplay = () => { };
		this.showMedalDisplay = () => { };
		this.showNewRankDisplay = () => { };
		this.showMapDistanceRecordDisplay = () => { };
		this.showCoachDisplay = () => { };
	}

	calculateDistance() {
		const landX = SJ.jumper.body.position.x;
		const { padPullingPoints } = SJ.V;
		const dist = landX - padPullingPoints[padPullingPoints.length - 1].x;

		this.jumpDistance = dist * SJ.V.PIXELS_TO_METERS;

		this.jumpDistance = Math.round(this.jumpDistance * 2) / 2;
	}

	calculateArbitersRate() {
		const arbiterRatePoints = SJ.V.arbiterRatePoints;
		let bonusPoints = 0;

		if (this.landingHeight >= 2 && this.landingHeight <= 3.5) {
			bonusPoints += 0.5;
			console.log(`%c Added point for landing height  +0,5`, 'color: red');
		}
		if (SJ.jumper.diffAngle >= -7 && SJ.jumper.diffAngle <= 7) {
			bonusPoints += 0.5;
			console.log(`%c Added point for landing angle +0,5`, 'color: red');
		}
		if (this.metersToEndOfPulling <= 3) {
			bonusPoints += 0.5;
			console.log(`%c Added point for jump moment +0,5`, 'color: red');
		}

		for (let i = 0; i < 5; i++) {
			let arbiterRate = 0;

			if (this.jumpDistance >= arbiterRatePoints[5]) {
				arbiterRate = 18 + SJ.Tools.getRandom(0, 1);
			} else if (this.jumpDistance >= arbiterRatePoints[4]) {
				arbiterRate = 16.5 + SJ.Tools.getRandom(0, 1.5);
			} else if (this.jumpDistance >= arbiterRatePoints[3]) {
				arbiterRate = 14.5 + SJ.Tools.getRandom(0, 2);
			} else if (this.jumpDistance >= arbiterRatePoints[2]) {
				arbiterRate = 12.5 + SJ.Tools.getRandom(0, 2);
			} else if (this.jumpDistance >= arbiterRatePoints[1]) {
				arbiterRate = 10.5 + SJ.Tools.getRandom(0, 2);
			} else if (this.jumpDistance >= arbiterRatePoints[0]) {
				arbiterRate = 8.5 + SJ.Tools.getRandom(0, 2);
			} else {
				arbiterRate = 6 + SJ.Tools.getRandom(0, 2.5);
			}

			arbiterRate = Math.floor(arbiterRate * 2) / 2;
			arbiterRate -= this.crashPoints;
			arbiterRate += bonusPoints;

			if (arbiterRate < 0) arbiterRate = 0;

			this.arbiterRates.push(arbiterRate);
			this.arbiterRatesScore += arbiterRate;
		}
	}

	calculateScore() {
		this.score = 60;
		const diff = this.jumpDistance - SJ.V.KPoint;

		this.score += diff * SJ.V.POINTS_PER_METER;
		this.score = this.score < 0 ? 0 : round(this.score, 1);

		this.metersToEndOfPulling =
			this.jumperJumpPoint !== 0
				? round(
					(SJ.V.jumpEndPoint - this.jumperJumpPoint) * SJ.V.PIXELS_TO_METERS,
					1
				)
				: '-';

		this.calculateArbitersRate();

		const maxRate = Math.max(...this.arbiterRates);
		const minRate = Math.min(...this.arbiterRates);

		this.arbiterRatesScore -= maxRate;
		this.arbiterRatesScore -= minRate;

		this.distanceScore = this.score;

		console.log(``);
		console.log(`Jump distance: ${this.jumpDistance}`);
		console.log(`Points for distance: ${this.distanceScore}`);
		console.log(`Points from arbiters: ${this.arbiterRatesScore}`);
		console.log(`Crash points -${this.crashPoints}`);

		this.score += this.arbiterRatesScore;

		console.log(`Total score: ${this.score}`);
		console.log(``);

		for (let i = 0; i < 5; i++) {
			if (this.arbiterRates[i] === maxRate) {
				this.arbiterRates[i] = `X${this.arbiterRates[i]}X`;
				break;
			}
		}

		for (let i = 0; i < 5; i++) {
			if (this.arbiterRates[i] === minRate) {
				this.arbiterRates[i] = `X${this.arbiterRates[i]}X`;
				break;
			}
		}

		console.log(`Jumped ${this.metersToEndOfPulling}m before end`);
		console.log(`Land height: ${this.landingHeight}m`);
		console.log(`Land angle: ${round(SJ.jumper.diffAngle, 2)}`);
		console.log(``);

		console.log(`K point: ${SJ.V.KPoint}m`);
		console.log(`Points per meter: ${SJ.V.POINTS_PER_METER}`);
		console.log(``);

		this.afterJump(this.score);
	}

	afterJump() {
		const p1 = 420;
		const p2 = 1.00871;

		this.moneyForLastJump = 0;
		const playerName = SJ.playerData.data['name'];

		const tournamentName = SJ.tournament ? SJ.tournament.name : 'false';

		this.showJumpScoreDisplay = () =>
			SJ.jumpScoreDisplay.show(
				this.jumpDistance,
				this.distanceScore,
				this.arbiterRates,
				this.arbiterRatesScore
			);

		this.showJumpParamDisplay = () =>
			SJ.jumpParamDisplay.show(
				this.jumpDistance,
				Math.floor(SJ.higherJumperHeight),
				this.jumperJumpSpeed,
				this.metersToEndOfPulling,
				SJ.higherJumperSpeed,
				Math.floor(SJ.jumper.diffAngle * 10) / 10,
				this.landingHeight,
				SJ.airSystem.windSpeed.min,
				SJ.airSystem.windSpeed.max,
				SJ.weather.weatherConditionRating,
				SJ.weather.weatherStatusIcon
			);

		if (playerName !== 'Guest') {
			let jumpsCountType = '';

			if (tournamentName !== 'false')
				jumpsCountType = 'tournamentDailyJumpsCount';
			else jumpsCountType = 'worldcupDailyJumpsCount';

			if (SJ.playerData.data[jumpsCountType] > SJ.V.maxDailyJumpsCount) {
				this.showCoachDisplay = () => SJ.coachDisplay.show(0, 0, 0);
				SJ.main._showJumpEndPopup();
				return;
			}
		}

		if (this.crashPoints === 0) {
			if (playerName !== 'Guest') {
				if (SJ.tournament) {
					SJ.playerData.data['tournamentRankingScore'] += this.score;
				} else {
					SJ.playerData.data['mapGlobalRankingScore'] += this.score;
				}

				const arbitersRatesString = `${this.arbiterRates[0]};${this.arbiterRates[1]};${this.arbiterRates[2]};${this.arbiterRates[3]};${this.arbiterRates[4]}`;

				let medalsCount = 0;
				for (let i = 0; i < SJ.V.medalsDistancePoints.length; i++) {
					if (this.jumpDistance >= SJ.V.medalsDistancePoints[i]) medalsCount++;
				}

				fetch(
					`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						let url = `
							${SJ.APILink}afterJump.php
							?userName=${playerName}
							&mapName=${SJ.currentLocationName}
							&score=${this.score}
							&jumpDist=${this.jumpDistance}
							&maxSpeed=${round(SJ.higherJumperSpeed, 2)}
							&maxHeight=${round(SJ.higherJumperHeight, 2)}
							&landingHeight=${this.landingHeight}
							&jumpMoment=${this.metersToEndOfPulling}
							&landingAngle=${SJ.jumper.diffAngle}
							&arbitersRates=${arbitersRatesString}
							&distanceScore=${this.score - this.arbiterRatesScore}
							&arbitersScore=${this.arbiterRatesScore}
							&pointsPerMeter=${SJ.V.POINTS_PER_METER}
							&KPoint=${SJ.V.KPoint}
							&medalsCount=${medalsCount}
							&moneyP1=${p1}
							&moneyP2=${p2}
							&minWindSpeed=${SJ.airSystem.windSpeed.min}
							&maxWindSpeed=${SJ.airSystem.windSpeed.max}
							&weatherConditionRating=${SJ.weather.weatherConditionRating}
							&weatherStateIcon=${SJ.weather.weatherStatusIcon}
							&tournamentName=${tournamentName}
							&key=${res}
							&jumpSpeed=${this.jumperJumpSpeed}
						`;

						// console.log(url);

						fetch(url)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								console.log('After jump feedback from server:');
								console.log(res);
								console.log('');

								const moneyForJump = parseInt(
									res.find((e) => e['moneyForJump']).moneyForJump
								);

								SJ.playerData.data['money'] += moneyForJump;
								SJ.playerData.data['successfulJumps'] += 1;
								this.moneyForLastJump = moneyForJump;

								if (SJ.playerData.data.successfulJumps === 1) {
									fbq('track', 'Donate', {
										currency: 'PLN',
										value: 1.5,
									});
								}

								const awardedMedals = res.find((e) => e['awardedMedals'])
									? res.find((e) => e['awardedMedals']).awardedMedals
									: null;
								const medalsBonusMoney = res.find((e) => e['medalsBonusMoney'])
									? res.find((e) => e['medalsBonusMoney']).medalsBonusMoney
									: 0;

								const rankBonusMoney = res.find((e) => e['rankBonusMoney'])
									? parseInt(
										res.find((e) => e['rankBonusMoney']).rankBonusMoney
									)
									: 0;
								const newRank = res.find((e) => e['newRank'])
									? res.find((e) => e['newRank']).newRank
									: '';

								if (awardedMedals && medalsBonusMoney > 0) {
									this.showMedalDisplay = () =>
										SJ.medalDisplay.show(
											awardedMedals[awardedMedals.length - 1].name,
											medalsBonusMoney
										);

									if (newRank) {
										this.showNewRankDisplay = () =>
											SJ.newRankDisplay.show(newRank, rankBonusMoney);
										SJ.playerData.data['mapGlobalRankingRank'] = newRank;
									}

									SJ.playerData.data['money'] +=
										medalsBonusMoney + rankBonusMoney;
								}

								const bonusArr = res.find(
									(e) => e['bonusForNewGlobalMapDistanceRecord']
								);
								const bonusForNewGlobalMapDistanceRecord = bonusArr
									? bonusArr['bonusForNewGlobalMapDistanceRecord']
									: null;

								if (res.find((e) => e['bonusForNewGlobalMapDistanceRecord'])) {
									this.showMapDistanceRecordDisplay = () =>
										SJ.mapRecordDisplay.show(
											this.jumpDistance,
											this.score,
											bonusForNewGlobalMapDistanceRecord
										);

									console.log(
										`New global map record. Bonus: ${bonusForNewGlobalMapDistanceRecord}`
									);
									SJ.playerData.data['money'] +=
										bonusForNewGlobalMapDistanceRecord;
								}

								if (res.find((e) => e === 'New personal map distance record')) {
									this.showCoachDisplay = () =>
										SJ.coachDisplay.show(
											this.moneyForLastJump,
											this.score,
											this.jumpDistance
										);
								} else {
									this.showCoachDisplay = () =>
										SJ.coachDisplay.show(this.moneyForLastJump, this.score, 0);
								}

								if (
									bonusForNewGlobalMapDistanceRecord ||
									medalsBonusMoney > 0
								) {
									window.setTimeout(
										() => SJ.crowdSoundContainer.play('buzzer'),
										2000
									);
								}

								SJ.main._showJumpEndPopup();
							});
					});
			} else {
				this.moneyForLastJump = round(p1 * Math.pow(p2, this.score));

				console.log(`Money for jump: ${this.moneyForLastJump}`);
				console.log('');

				SJ.playerData.data['successfulJumps'] += 1;

				this.showCoachDisplay = () =>
					SJ.coachDisplay.show(this.moneyForLastJump, this.score, 0);

				SJ.main._showJumpEndPopup();
			}
		} else {
			SJ.main._showJumpEndPopup();
		}
	}
};
